import { useEffect, useState } from 'react';
import { ActiveOrderIcon } from '../../../utils/svg';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { useDispatch, useSelector } from 'react-redux';
import { uniqueID } from '../../../utils/constants';
import { encodeValue, isEmptyData } from '../../../utils/helper';
import { getOrderListV2 } from '../../../store/reducers/order';
import useNavigation from '../../../hook/useNavigation';

const ActiveOrder = () => {
	const dispatch = useDispatch();
	const navigate = useNavigation();
	const user = useSelector((store) => store?.user);
	const { delivering, processing, pending } = useSelector((store) => store?.order);
	const [isChatOpen, setIsChatOpen] = useState(false);
  const [isBackground, setIsBackground] = useState(false)

	const handleGetOrder = async () => {
		if (!user?.token) return;
		try {
			dispatch(
				getOrderListV2({
					unquieid: uniqueID,
					orderType: 'Ongoing',
				}),
			);
		} catch (error) {
			console.log('error: ', error);
		}
	};

	const handleClick = () => {
		navigate.push(`/history/all`);
	};

	useEffect(() => {
		handleGetOrder();
	}, [user?.token]);

	useEffect(() => {
		const handleOpen = () => {
			setIsChatOpen(true);
		};

		const handleClose = () => {
			setIsChatOpen(false);
		};

		window.addEventListener('freshchat:open', handleOpen);
		window.addEventListener('freshchat:close', handleClose);

    return () => {
      try {
        window.removeEventListener('freshchat:open', handleOpen);
        window.removeEventListener('freshchat:close', handleClose);
      } catch (error) {
        console.warn('Failed to remove freshchat listeners', error);
      }
    };
	}, []);

  	useEffect(() => {
		const handleChange = (event) => {
			setIsBackground(Boolean(event?.detail?.isOpen));
		};

		window.addEventListener('modal:change', handleChange);

		return () => {
			try {
				window.removeEventListener('modal:change', handleChange);
			} catch (error) {
				console.warn('Failed to remove modal:change listener', error);
			}
		};
	}, []);

	if ((isEmptyData(delivering) && isEmptyData(processing) && isEmptyData(pending)) || isChatOpen) return null;

	return (
		<>
      <div className={`${(isEmptyData(delivering) && isEmptyData(processing) && isEmptyData(pending)) ? 'hidden' : 'h-16' }`} />
			<div className={`fixed left-1/2 -translate-x-1/2 bottom-5 ${isBackground ? 'z-0' : 'z-[6]'}`} onClick={handleClick}>
				<div className='flex items-center justify-between bg-[var(--rose-violet)] text-white rounded-lg px-6 py-4'>
					<ActiveOrderIcon className={'mr-4 h-6'} />
					<div className='flex items-center whitespace-nowrap gap-1'>
						<div className='text-sm font-semibold capitalize'>Active Order</div>
						<div className='bg-red-400 size-6 flex items-center justify-center rounded-full text-xs font-bold'>{(delivering?.length + processing?.length + pending?.length) || 0}</div>
					</div>
					<ChevronRightIcon className='h-4 w-4 text-white flex-shrink-0 ml-5' strokeWidth={3} />
				</div>
			</div>
		</>
	);
};

export default ActiveOrder;
